// EN translations for v2/pages/account.js (gettext pattern: the ITALIAN string is the key).
const m = {
  // ── Modali / azioni comuni ──
  'Chiudi': 'Close',
  'Annullare': 'Cancel',
  'Avanti': 'Next',
  'Registrare': 'Save',
  'Convalidare': 'Validate',
  'Modificare': 'Edit',
  'Modifica': 'Edit',
  'Gestire': 'Manage',
  'Aggiungi': 'Add',
  'Elimina': 'Delete',
  'Eliminare': 'Delete',
  'Home': 'Home',
  'Il mio profilo': 'My profile',

  // ── SupportCode ──
  'Si aggiorna tra {ttl}s': 'Updates in {ttl}s',

  // ── EmailConnModal ──
  "Impossibile aggiornare l'e-mail. Verifica la password inserita.": 'Unable to update the email. Check the password you entered.',
  'Modifica il tuo indirizzo e-mail di accesso': 'Edit your login email address',
  'E-mail di accesso attuale:': 'Current login email:',
  'Nuova e-mail di accesso *': 'New login email *',
  'Conferma il nuovo indirizzo e-mail di accesso *': 'Confirm the new login email address *',
  "Per convalidare l'aggiornamento inserisci": 'To confirm the change, enter',
  'la password di accesso attuale.': 'your current login password.',
  'Password di accesso *': 'Login password *',

  // ── EditPersonalModal ──
  'Impossibile salvare. Riprova.': 'Unable to save. Please try again.',
  'Modifica le informazioni personali': 'Edit personal information',
  'Nome *': 'First name *',
  'Cognome *': 'Last name *',

  // ── DeleteAccountModal ──
  'Richiesta presa in carico. Il nostro team ti contatterà per completare la procedura.': 'Request received. Our team will contact you to complete the process.',
  'Dichiaro di aver letto e capito': 'I declare that I have read and understood',
  'Stai per': 'You are about to',
  'eliminare definitivamente': 'permanently delete',
  'il tuo account. Continuare veramente?': 'your account. Do you really want to continue?',
  'Il tuo utente': 'Your user',
  'è il responsabile legale o l’ultimo contatto di fatturazione sull’account.': 'is the legal representative or the last billing contact on the account.',
  'Per rimuovere il tuo utente': 'To remove your user',
  ', devi prima designare un altro responsabile legale o un contatto di fatturazione dell’organizzazione.': ', you must first designate another legal representative or a billing contact for the organization.',
  'Hai': 'You have',
  'servizio attivo': 'active service',
  'servizi attivi': 'active services',
  ': prima di eliminare l’account devi disdirli o trasferirli.': ': before deleting the account you must cancel or transfer them.',
  'Se sei l’ultimo utente della tua organizzazione, puoi eliminarla dalla pagina «Organizzazione». Per completare l’eliminazione dell’account, contatta l’assistenza.': 'If you are the last user in your organization, you can delete it from the «Organization» page. To complete the account deletion, contact support.',

  // ── OrganizationsModal ──
  'Le mie organizzazioni': 'My organizations',
  'Il tuo profilo utente è collegato a': 'Your user profile is linked to',
  '1 organizzazione.': '1 organization.',
  'Creare una nuova organizzazione': 'Create a new organization',
  'Responsabile legale': 'Legal representative',
  'Organizzazione corrente': 'Current organization',
  'Non puoi scollegarti dalla tua organizzazione attuale': 'You cannot unlink from your current organization',

  // ── NewsletterModal ──
  'Newsletter': 'Newsletter',
  'Seleziona': 'Select',
  'le tematiche NeoFlux': 'the NeoFlux topics',
  'per ricevere le newsletter relative ad esse.': 'to receive the related newsletters.',
  'Novità NeoFlux': 'NeoFlux news',

  // ── SecuritySettingsModal ──
  'Impostazioni di sicurezza': 'Security settings',
  'Seleziona i casi per i quali vuoi essere avvisato tramite e-mail.': 'Select the cases for which you want to be notified by email.',
  "Blocco dell'account dopo il numero predefinito di tentativi di connessione consecutivi non riusciti.": 'Account lockout after the default number of consecutive failed login attempts.',
  'Numero di tentativi :': 'Number of attempts:',
  'Tentativi di connessione non riusciti': 'Failed login attempts',
  'Connessioni riuscite': 'Successful logins',

  // ── RecoveryEmailModal ──
  "Modifica l'indirizzo e-mail di recupero": 'Edit the recovery email address',
  'Aggiungi un indirizzo e-mail di recupero': 'Add a recovery email address',
  'Consigliamo di aggiungere un': 'We recommend adding a',
  'indirizzo e-mail di recupero': 'recovery email address',
  'al tuo account. Questo potrà essere utilizzato per reimpostare la password qualora tu la dimentichi.': 'to your account. It can be used to reset your password if you forget it.',
  'E-mail di recupero *': 'Recovery email *',
  "Conferma l'indirizzo e-mail *": 'Confirm the email address *',
  'Password *': 'Password *',

  // ── PhoneRecoveryModal ──
  'Modifica il tuo numero di recupero': 'Edit your recovery number',
  'Quale numero di telefono vuoi utilizzare come numero di recupero? Questo numero sarà utilizzato in caso di perdita della tua password.': 'Which phone number do you want to use as your recovery number? This number will be used if you lose your password.',
  'Telefono *': 'Phone *',

  // ── Profilo (header) / lingue ──
  'Lingua': 'Language',
  'Paese': 'Country',
  'Fuso orario': 'Time zone',
  'Documenti legali': 'Legal documents',
  'Consultare': 'View',
  'Modifica lingua': 'Edit language',
  'Modifica paese': 'Edit country',
  'Modifica fuso orario': 'Edit time zone',
  'Italiano': 'Italian',
  'English': 'English',
  'Español': 'Spanish',
  'Français': 'French',
  'Deutsch': 'German',

  // ── Suite collaborativa (app tile) ──
  'Posta': 'Mail',
  'Drive': 'Drive',

  // ── UtentiPage ──
  'Gestione degli utenti': 'User management',
  'Utenti': 'Users',
  'Utente': 'User',
  'Aggiungere un utente': 'Add a user',
  "Utenti dell'organizzazione": 'Organization users',
  'Ruolo': 'Role',
  'Gruppi': 'Groups',
  'Suite collaborativa': 'Collaborative suite',
  'Prodotti': 'Products',
  'Colonne': 'Columns',
  'Aggiungi a un gruppo': 'Add to a group',
  'Altre applicazioni': 'Other applications',
  'Tutti': 'All',
  'Risultati per pagina': 'Results per page',
  'Pagina {n} di {m}': 'Page {n} of {m}',

  // ── GruppiPage ──
  'Gruppo': 'Group',
  'Crea un gruppo': 'Create a group',
  'Cerca un gruppo…': 'Search for a group…',
  'Nessun gruppo': 'No groups',
  'Crea un gruppo per organizzare gli utenti e i loro permessi.': 'Create a group to organize users and their permissions.',

  // ── RapportoAttivitaPage ──
  'Rapporto di attività': 'Activity report',
  'Cronologia delle attività': 'Activity history',
  'Visualizza fino a un anno di cronologia degli accessi degli utenti alla tua organizzazione.': 'View up to one year of user access history for your organization.',
  'registri': 'logs',
  'Caricamento…': 'Loading…',
  'Nessuna attività registrata': 'No recorded activity',
  'Nome': 'Name',
  'Azione': 'Action',
  'Data': 'Date',
  'Prodotto': 'Product',
  'Descrizione': 'Description',

  // ── ImpostazioniAccountPage ──
  'Sicurezza e impostazioni di recupero': 'Security and recovery settings',
  'Ottima': 'Excellent',
  'Critica': 'Critical',
  'Attiva la convalida in due fasi': 'Enable two-step verification',
  'Convalida in due fasi': 'Two-step verification',
  'Password compromessa?': 'Password compromised?',
  'Proteggi i tuoi accessi': 'Protect your logins',
  'Correggi adesso': 'Fix now',
  'Impostazioni di accesso': 'Login settings',
  'Indirizzo e-mail di connessione': 'Login email address',
  'Password di accesso': 'Login password',
  'Modificato il': 'Changed on',
  "Accesso e attività dell'account": 'Account access and activity',
  'dispositivo connesso': 'connected device',
  'dispositivi connessi': 'connected devices',
  'a questo account': 'to this account',
  "Password dell'applicazione": 'Application passwords',
  "password dell'applicazione": 'application passwords',
  'Supporto': 'Support',
  'Autorizzazione di accesso': 'Access authorization',
  'autorizzazione': 'authorization',
  'Codice supporto': 'Support code',
  'organizzazione': 'organization',
  'News NeoFlux': 'NeoFlux news',
  'abbonamento(i)': 'subscription(s)',
  'Applicazioni': 'Applications',
  'Consulta gli accessi alle tue applicazioni': 'View access to your applications',
  'Leggi la documentazione per gli sviluppatori': 'Read the developer documentation',

  // ── PasswordPage ──
  'Gestione delle password': 'Password management',
  'Modifica della tua password di accesso': 'Change your login password',
  'Password aggiornata *': 'Current password *',
  'Quale sarà la tua nuova password?': 'What will your new password be?',
  'Nuova password *': 'New password *',
  'Minuscolo': 'Lowercase',
  'Maiuscolo': 'Uppercase',
  'Numero': 'Number',
  'Caratteri': 'Characters',
  'Conferma della nuova password *': 'Confirm the new password *',
  'Salva la nuova password': 'Save the new password',

  // ── AppPasswordPage ──
  'Adesso, ogni dispositivo ha la propria password.': 'Now, each device has its own password.',
  'Per più informazioni': 'More information',
  'Cerca una password': 'Search for a password',
  "Crea una password dell'applicazione": 'Create an application password',
  "Nessuna password dell'applicazione": 'No application passwords',
  'Non hai ancora creato la password delle tue applicazioni': 'You have not created any application passwords yet',

  // ── AccessoPage ──
  'Accesso e attività': 'Access & activity',
  'Questa pagina ti consente di verificare le sessioni attive e i dispositivi dai quali sei connesso al tuo account utente': 'This page lets you check the active sessions and devices from which you are connected to your user account',
  "Accesso all'account": 'Account access',
  "Attività dell'account": 'Account activity',
  'sessione': 'session',
  'sessioni': 'sessions',
  'Sei connesso al tuo account utente sulle sessioni seguenti. Se non riconosci nessuna di esse,': 'You are connected to your user account on the following sessions. If you do not recognize any of them,',
  'ripristina la connessione disconnettendoti': 'restore the connection by logging out',
  ". Dovrai quindi rieffettuare l'accesso con le tue credenziali abituali.": '. You will then need to log in again with your usual credentials.',
  'Cerca una sessione': 'Search for a session',
  'Nessuna sessione attiva': 'No active sessions',
  'Dispositivo': 'Device',
  'Piattaforma': 'Platform',
  'Posizione': 'Location',
  'Data di accesso': 'Login date',
  'Sconosciuta': 'Unknown',
  'Disconnetti': 'Disconnect',
  'attività': 'activities',
  'Controlla fino a un anno indietro la cronologia delle attività relative al tuo account utente. Controllate regolarmente la sicurezza del vostro': 'Check up to one year back the activity history for your user account. Regularly check the security of your',
  'account': 'account',
  'alla ricerca di attività sospette.': 'for suspicious activity.',
  'Filtra': 'Filter',
  'Azioni': 'Actions',
  'Descrizioni': 'Descriptions',

  // ── SicurezzaPage ──
  "Sicurezza dell'account": 'Account security',
  'Proteggi il tuo account aggiungendo le': 'Protect your account by adding the',
  'informazioni mancanti.': 'missing information.',
  'Accresci la sicurezza del tuo account attivando la convalida in due fasi': 'Increase your account security by enabling two-step verification',
  'Attiva': 'Active',
  'Disattiva': 'Disable',
  'Attiva adesso': 'Activate now',
  'Dispositivi connessi': 'Connected devices',
  'Disconnetti tutto': 'Disconnect all',
  'Indirizzo e-mail di recupero': 'Recovery email address',
  'Questa informazione è essenziale se dimentichi la password.': 'This information is essential if you forget your password.',
  'Telefono di recupero': 'Recovery phone',
  'Conferma il numero': 'Confirm the number',

  // ── Doppia2faPage ──
  'Scelta del metodo di convalida': 'Choose the verification method',
  'Configurazione': 'Configuration',
  'Verifica': 'Verification',
  "Codici d'emergenza": 'Emergency codes',
  "Codici d'emergenza NeoFlux": 'NeoFlux emergency codes',
  'Applicazione OTP': 'OTP application',
  "Installa un'applicazione OTP di terzi (Google Authenticator, Authy…).": 'Install a third-party OTP application (Google Authenticator, Authy…).',
  'Configurare': 'Configure',
  'Utilizzare uno Yubikey (tramite OTP) per convalidare la propria identità.': 'Use a Yubikey (via OTP) to verify your identity.',
  'Come vuoi convalidare le tue connessioni?': 'How do you want to verify your connections?',
  'La convalida in due fasi protegge il tuo account NeoFlux dagli hacker, anche se sono in possesso della tua password.': 'Two-step verification protects your NeoFlux account from hackers, even if they have your password.',
  'Aggiungi questo metodo': 'Add this method',
  "Configurazione di un'applicazione mobile OTP": 'Configuring a mobile OTP application',
  "Associa l'applicazione mobile OTP al tuo account utente seguendo le istruzioni sottostanti.": 'Link the mobile OTP application to your user account by following the instructions below.',
  "Apri l'applicazione e aggiungi il tuo account utente facendo clic su «+».": 'Open the application and add your user account by clicking «+».',
  'Inserisci manualmente la chiave seguente nella tua applicazione.': 'Manually enter the following key in your application.',
  'Scansiona questo codice QR dal tuo telefono cellulare e verifica di essere correttamente connesso a Internet.': 'Scan this QR code from your mobile phone and make sure you are properly connected to the Internet.',
  'Preferisco scansionare il codice QR': 'I prefer to scan the QR code',
  'Non riesco a scansionare il codice QR': "I can't scan the QR code",
  'Collega la tua Yubikey': 'Connect your Yubikey',
  'Inserisci la tua Yubikey in una porta USB e toccala per registrarla come metodo di convalida.': 'Insert your Yubikey into a USB port and tap it to register it as a verification method.',
  'Inserisci il codice a 6 cifre generato dalla tua applicazione per completare la configurazione.': 'Enter the 6-digit code generated by your application to complete the setup.',
  'Codice di verifica *': 'Verification code *',
  'Hai accresciuto la sicurezza del tuo account': 'You have increased your account security',
  "Scarica i codici d'emergenza: potrai usarli per accedere se non hai a disposizione il tuo metodo di convalida.": 'Download the emergency codes: you can use them to log in if your verification method is unavailable.',
  'Stampare': 'Print',
  'Scaricare': 'Download',
  'Conserva questi codici in un luogo sicuro e accessibile.': 'Keep these codes in a safe and accessible place.',
  'Fine': 'Done',
  'Configura la convalida in due fasi': 'Set up two-step verification',
  'Per aggiungere un nuovo metodo di autenticazione, inserisci la': 'To add a new authentication method, enter the',
  'password di accesso.': 'login password.',

  // ── SupportoAccountPage ──
  "Autorizza temporaneamente l'Assistenza ad accedere al Servizio mail": 'Temporarily authorize Support to access the mail service',
  "Autorizza temporaneamente l'Assistenza ad accedere ai servizi cloud": 'Temporarily authorize Support to access cloud services',
  "Autorizza temporaneamente l'assistenza tecnica ad accedere ai messaggi": 'Temporarily authorize technical support to access messages',
  "Accesso all'Assistenza": 'Access to Support',
  "A volte, è necessario accedere al tuo account per risalire all'origine di un problema. L'autorizzazione è": 'Sometimes it is necessary to access your account to trace the source of a problem. The authorization is',
  'valida 7 giorni': 'valid for 7 days',
  'e può essere ritirata in qualsiasi momento.': 'and can be revoked at any time.',
  'Codice Assistenza': 'Support code',
  'Qualora tu contatti il nostro servizio di assistenza per telefono, ti preghiamo di fornire questo codice. Il nostro servizio di assistenza è disponibile dal lunedì al venerdì dalle 09:00 alle 18:00.': 'If you contact our support service by phone, please provide this code. Our support service is available Monday to Friday from 09:00 to 18:00.',

  // ── TokenPage ──
  'Token API': 'API tokens',
  'Crea un token': 'Create a token',
  'Gestione dei token API': 'API token management',
  "L'API NeoFlux ti consente di gestire i prodotti tramite le tue interfacce senza passare dal Manager.": 'The NeoFlux API lets you manage your products through your own interfaces without going through the Manager.',
  'Consulta la documentazione.': 'Read the documentation.',
  "Un token consente di consultare l'API NeoFlux con il proprio account utente. Il codice ottenuto è": 'A token lets you access the NeoFlux API with your user account. The code you obtain is',
  'riservato': 'confidential',
  'e non deve essere divulgato per nessuna ragione.': 'and must not be disclosed for any reason.',
  'token': 'tokens',
  "Cerca un'applicazione o uno scope": 'Search for an application or scope',
  'Nessun risultato': 'No results',

  // ── ApplicazioniApiPage ──
  'Applicazione API': 'API applications',
  "Crea un'applicazione": 'Create an application',
  'Applicazione API NeoFlux': 'NeoFlux API application',
  'Crea applicazioni OAuth2 per accedere ai tuoi servizi esterni tramite il tuo nome utente NeoFlux.': 'Create OAuth2 applications to access your external services using your NeoFlux username.',
  'Non hai nessuna applicazione API NeoFlux': 'You have no NeoFlux API applications',
  'Non hai ancora creato applicazioni.': 'You have not created any applications yet.',
  'Crea una nuova applicazione': 'Create a new application',
};
export default m;
